const copyrightEl = document.getElementById('copyright-date');
if (copyrightEl) {
    copyrightEl.textContent = String(new Date().getFullYear());
}
